import { InjectionToken } from '@angular/core';
import { environment } from '@environments/environment';

export const API_ENDPOINTS = new InjectionToken('api endpoints', {
  providedIn: 'root',
  factory: () => environment.endpoints,
});
